module.exports = __webpack_public_path__ + "static/media/serv_nvph1.e6489078.webp";